import UBBundleSelect from 'components/commercetools-ui/aafes/uniform-builder/bundle-select';
import React from 'react';

const UBBundleSelectTastic = ({ data }) => {
  return <UBBundleSelect account={data?.account?.dataSource} />;
};

export default UBBundleSelectTastic;
